<template>
    <span >
        <p @click="ativasMetrica = !ativasMetrica" class="btn text-xl select-none cursor-pointer uppercase text-center mb-4 text-indigo-500 dark:text-gray-500"> {{ativasMetrica ? 'Ativas' : 'Adesão'}}</p>
        <transition name="fade">
        <div v-if="ativasMetrica">
            <span class="grid grid-cols-2 gap-y-4 divide-y divide-gray-300 dark:divide-gray-600 divide-solid">
                <span class="grid grid-cols-2 col-span-2">
                    <p class="text-xl text-center text-gray-500 dark:text-gray-200">Pendentes</p>
                    <p class="text-xl text-center text-gray-500 dark:text-gray-200">Concluídas</p>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(8)" class="text-xs text-center col-span-2 uppercase ">Importação automatizada</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[1] ? metricasPesquisador.ativa[1]["Importação automatizada"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[0] ? metricasPesquisador.ativa[0]["Importação automatizada"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(9)" class="text-xs text-center col-span-2 uppercase ">Loja Cancelada pelo Responsável</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[1] ? metricasPesquisador.ativa[1]["Loja Cancelada pelo Responsável"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[0] ? metricasPesquisador.ativa[0]["Loja Cancelada pelo Responsável"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(10)" class="text-xs text-center col-span-2 uppercase ">Responsável ausente em todas tentativas</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[1] ? metricasPesquisador.ativa[1]["Responsável ausente em todas tentativas"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[0] ? metricasPesquisador.ativa[0]["Responsável ausente em todas tentativas"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(11)" class="text-xs text-center col-span-2 uppercase ">Sem venda no periodo auditado</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[1] ? metricasPesquisador.ativa[1]["Sem venda no periodo auditado"] : '—')}}</p>
                <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[0] ? metricasPesquisador.ativa[0]["Sem venda no periodo auditado"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(14)" class="text-xs text-center col-span-2 uppercase ">Recolha em progresso</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[1] ? metricasPesquisador.ativa[1]["Recolha em progresso"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[0] ? metricasPesquisador.ativa[0]["Recolha em progresso"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(12)" class="text-xs text-center col-span-2 uppercase ">Recolha Realizada</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[1] ? metricasPesquisador.ativa[1]["Recolha Realizada"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[0] ? metricasPesquisador.ativa[0]["Recolha Realizada"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p class="text-xs text-center col-span-2 uppercase text-gray-500 dark:text-gray-100">Total</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[1] ? metricasPesquisador.ativa[1]["SUB TOTAL"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.ativa[0] ? metricasPesquisador.ativa[0]["SUB TOTAL"] : '—')}}</p>
                    </span>
                </span>
            </span>
        </div>
        <div v-else>
            <span class="grid grid-cols-2 gap-y-4 divide-y divide-gray-300 dark:divide-gray-600 divide-solid">
                <span class="grid grid-cols-2 col-span-2">
                    <p class="text-xl text-center text-gray-500 dark:text-gray-200">Pendentes</p>
                    <p class="text-xl text-center text-gray-500 dark:text-gray-200">Concluídas</p>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(5)" class="text-xs text-center col-span-2 uppercase ">Agendado</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["Agendado"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["Agendado"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(13)" class="text-xs text-center col-span-2 uppercase ">Cadastro de Loja Manual</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["Cadastro de Loja Manual"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["Cadastro de Loja Manual"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(7)" class="text-xs text-center col-span-2 uppercase ">Desistente</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["Desistente"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["Desistente"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(8)" class="text-xs text-center col-span-2 uppercase ">Importação automatizada</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["Importação automatizada"] : '—')}}</p>
                <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["Importação automatizada"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(1)" class="text-xs text-center col-span-2 uppercase ">Não Atende</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["Não Atende"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["Não Atende"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(3)" class="text-xs text-center col-span-2 uppercase ">Número Errado</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["Número Errado"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["Número Errado"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(6)" class="text-xs text-center col-span-2 uppercase ">OK Cadastrado</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["OK Cadastrado"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["OK Cadastrado"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(2)" class="text-xs text-center col-span-2 uppercase ">Ocupado</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["Ocupado"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["Ocupado"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p :class="getStatusColor(4)" class="text-xs text-center col-span-2 uppercase ">Recusa Participar</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid mt-2">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["Recusa Participar"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["Recusa Participar"] : '—')}}</p>
                    </span>
                </span>
                <span class="grid grid-cols-2 col-span-2 pt-4">
                    <p class="text-xs text-center col-span-2 uppercase text-gray-500 dark:text-gray-100">Total</p>
                    <span class="grid grid-cols-2 col-span-2 divide-x divide-gray-300 dark:divide-gray-600 divide-solid">
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[1] ? metricasPesquisador.adesao[1]["SUB TOTAL"] : '—')}}</p>
                        <p class="text-3xl text-center text-gray-500 dark:text-gray-100">{{(pesquisador && metricasPesquisador.adesao[0] ? metricasPesquisador.adesao[0]["SUB TOTAL"] : '—')}}</p>
                    </span>
                </span>

            </span>
        </div>
        </transition>
    </span>
</template>

<script>

import { ref } from '@vue/reactivity'
import { computed, watch } from '@vue/runtime-core'
import { getStatusColor as getColor } from '../../mixins/colors'

export default {
    props: ['pesquisador', 'metrics'],
    setup (props, { emit }) {
        const ativasMetrica = ref(true)

        const metricasPesquisador = computed(() => {
            if (props.pesquisador) {
                const lojaAtivaConcluido = props.metrics.lojaAtiva ? props.metrics.lojaAtiva.concluido.filter(x => x.Nome === props.pesquisador)[0] : []
                const lojaAtivaPendente = props.metrics.lojaAtiva ? props.metrics.lojaAtiva.pendente.filter(x => x.Nome === props.pesquisador)[0] : []
                const lojaAdesaoConcluido = props.metrics.lojaAdesao ? props.metrics.lojaAdesao.concluido.filter(x => x.Nome === props.pesquisador)[0] : []
                const lojaAdesaoPendente = props.metrics.lojaAdesao ? props.metrics.lojaAdesao.pendente.filter(x => x.Nome === props.pesquisador)[0] : []
                return { ativa: [lojaAtivaConcluido, lojaAtivaPendente], adesao: [lojaAdesaoConcluido, lojaAdesaoPendente] }
            }
            return {}
        })

        watch(() => props.pesquisador, (n, o) => {
            emit('update', chartData.value)
        })

        watch(() => props.metrics, (n, o) => {
            emit('update', chartData.value)
        })

        watch(() => ativasMetrica.value, (n, o) => {
            
            emit('changeType', n)
        })

        const getStatusColor = getColor

        const chartData = computed(() => {
            if (props.pesquisador) {
                return {
                    lojaAtiva: {
                        pendente: [
                            metricasPesquisador.value.ativa[1] ? parseInt(metricasPesquisador.value.ativa[1]['Importação automatizada']) : 0,
                            metricasPesquisador.value.ativa[1] ? parseInt(metricasPesquisador.value.ativa[1]['Loja Cancelada pelo Responsável']) : 0,
                            metricasPesquisador.value.ativa[1] ? parseInt(metricasPesquisador.value.ativa[1]['Responsável ausente em todas tentativas']) : 0,
                            metricasPesquisador.value.ativa[1] ? parseInt(metricasPesquisador.value.ativa[1]['Sem venda no periodo auditado']) : 0,
                            metricasPesquisador.value.ativa[1] ? parseInt(metricasPesquisador.value.ativa[1]['Recolha em progresso']) : 0,
                            metricasPesquisador.value.ativa[1] ? parseInt(metricasPesquisador.value.ativa[1]['Recolha Realizada']) : 0
                        ],
                        concluida: [
                            metricasPesquisador.value.ativa[0] ? parseInt(metricasPesquisador.value.ativa[0]['Importação automatizada']) : 0,
                            metricasPesquisador.value.ativa[0] ? parseInt(metricasPesquisador.value.ativa[0]['Loja Cancelada pelo Responsável']) : 0,
                            metricasPesquisador.value.ativa[0] ? parseInt(metricasPesquisador.value.ativa[0]['Responsável ausente em todas tentativas']) : 0,
                            metricasPesquisador.value.ativa[0] ? parseInt(metricasPesquisador.value.ativa[0]['Sem venda no periodo auditado']) : 0,
                            metricasPesquisador.value.ativa[0] ? parseInt(metricasPesquisador.value.ativa[0]['Recolha em progresso']) : 0,
                            metricasPesquisador.value.ativa[0] ? parseInt(metricasPesquisador.value.ativa[0]['Recolha Realizada']) : 0
                        ]
                    },
                    lojaAdesao: {
                        pendente: [
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1].Agendado) : 0,
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1]['Cadastro de Loja Manual']) : 0,
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1].Desistente) : 0,
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1]['Importação automatizada']) : 0,
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1]['Não Atende']) : 0,
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1]['Número Errado']) : 0,
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1]['OK Cadastrado']) : 0,
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1].Ocupado) : 0,
                            metricasPesquisador.value.adesao[1] ? parseInt(metricasPesquisador.value.adesao[1]['Recusa Participar']) : 0
                        ],
                        concluida: [
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0].Agendado) : 0,
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0]['Cadastro de Loja Manual']) : 0,
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0].Desistente) : 0,
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0]['Importação automatizada']) : 0,
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0]['Não Atende']) : 0,
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0]['Número Errado']) : 0,
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0]['OK Cadastrado']) : 0,
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0].Ocupado) : 0,
                            metricasPesquisador.value.adesao[0] ? parseInt(metricasPesquisador.value.adesao[0]['Recusa Participar']) : 0
                        ]
                    }
                }
            } else {
                return {
                    lojaAtiva: {
                        pendente: [0, 0, 0, 0, 0, 0],
                        concluida: [0, 0, 0, 0, 0, 0]
                    },
                    lojaAdesao: {
                        pendente: [0, 0, 0, 0, 0, 0, 0, 0, 0],
                        concluida: [0, 0, 0, 0, 0, 0, 0, 0, 0]
                    }
                }
            }
        })

        return {
            ativasMetrica,
            metricasPesquisador,
            getStatusColor
        }
    }
}
</script>

<style scoped>

.fade-enter-from {
  opacity: 0;
  transform: translateX(10%);
}
.fade-enter-to {
  opacity: 1;
  transform: translateX(0%);
}

.fade-enter-active {
  transition: all 0.5s ease-in-out;
  transition-delay: 0.5s;
}

.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
  transform: translateX(0%);
}

.fade-leave-to {
  opacity: 0;
  transform: translateX(10%);
}
</style>
